import { cva, type VariantProps } from 'class-variance-authority'

/**
 * Badge component style variants
 * Definește stilurile pentru componenta Badge (etichete produse, status-uri)
 *
 * Design tokens from tailwind.config.js:
 * - custom-green (#4E9B00) - Success/in-stock color
 * - custom-red (#d7263d) - Error/out-of-stock/discount color
 * - main-color (#F7B01A) - Warning/promo color
 * - text-color (#1c1b21) - Main text color
 */
export const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-transparent text-text-color',
        secondary: 'border-transparent bg-secondary text-secondary-foreground hover:brightness-110',
        destructive: 'border-transparent bg-destructive text-destructive-foreground hover:brightness-110',
        outline: 'text-foreground',
        success: 'border-transparent bg-transparent text-custom-green',
        warning: 'border-transparent bg-main-color text-text-color hover:brightness-110',
        info: 'border-transparent bg-primary text-primary-foreground hover:brightness-110',

        // Product-specific variants
        inStock: 'border-transparent bg-transparent text-custom-green',
        outOfStock: 'border-transparent bg-custom-red text-white',
        discount: 'border-transparent bg-custom-red text-white font-bold',
        promo: 'border-transparent bg-main-color text-text-color font-bold',
      },
      size: {
        default: 'px-2.5 py-0.5 text-xs',
        sm: 'px-2 py-0.5 text-[10px]',
        lg: 'px-3 py-1 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
